namespace RioERP.Shipping {
    export namespace ShippingTrackingNumbersService {
        export const baseUrl = 'Shipping/ShippingTrackingNumbers';

        export declare function Create(request: Serenity.SaveRequest<ShippingTrackingNumbersRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ShippingTrackingNumbersRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ShippingTrackingNumbersRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ShippingTrackingNumbersRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ExcelImport(request: ExcelImportRequest, onSuccess?: (response: ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Shipping/ShippingTrackingNumbers/Create",
            Update = "Shipping/ShippingTrackingNumbers/Update",
            Delete = "Shipping/ShippingTrackingNumbers/Delete",
            Retrieve = "Shipping/ShippingTrackingNumbers/Retrieve",
            List = "Shipping/ShippingTrackingNumbers/List",
            ExcelImport = "Shipping/ShippingTrackingNumbers/ExcelImport"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'ExcelImport'
        ].forEach(x => {
            (<any>ShippingTrackingNumbersService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
